import {useConfiguration} from '../../../hooks/configuration';
import {getMsFromS} from '../../../utils/datetime';
import {useGetEventSoundQuery} from '../api/eventSummaryApi';

export const useEventSoundPolling = () => {
  const refresh = useConfiguration('commtrac', 'commtrac_sound_interval');
  const pollingInterval = refresh?.value ? getMsFromS(+refresh.value) : undefined;

  useGetEventSoundQuery(undefined, {
    pollingInterval: pollingInterval ?? undefined,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
};
